import { AbandonedCartItemArray, AbandonedCartItem } from './../../models/ss-api/responses/abandoned.cart.item';
import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { SortBot } from '../../../app/helpers/sort';
import { Router } from '@angular/router';
import { Angular2Csv } from 'angular2-csv';
import { InvoiceDetailsDialog } from '../../../app/dialogs/invoice.details/invoice.details.dialog';

import * as moment from 'moment';
import { LicenseManager } from '../../managers/License.manager';

@Component({
    selector: 'abandoned-cart-report',
    templateUrl: './abandoned.cart.report.component.html',
    styleUrls: ['./abandoned.cart.report.component.scss']
})

export class AbandonedCartComponent implements OnInit {
    IsBusy: boolean = false;

    AbandonedCartItems: AbandonedCartItemArray;
    HiddenAbandonedCartItems: AbandonedCartItemArray;
    AbandonedCartFilter: string;
    AutomatedBillingStartDate: Date = moment().subtract(30, 'days').toDate();
    AutomatedBillingEndDate: Date = moment().toDate();

    ShowHidden: boolean = false;
    HiddenCartLabel: string = 'Show';

    constructor(private dialogService: DialogService,
        private api: ssApiService,
        private gb: GlobalService,
        private sweetAlert: SweetAlertService,
        private router: Router) { }

    ngOnInit() {
        this.gb.SetPageTitle('Abandoned Cart Report');

        this.GetAbandonedCarts();
    }

    sortBy(sortVar1, sortVar2?) {
        this.AbandonedCartItems = SortBot.SortAuto(this.AbandonedCartItems, sortVar1, sortVar2);
    }

    onMemberClick(id: number) {
        this.router.navigate(['/member-profile', id]);
    }

    onLicenseClick(key: string) {
        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(key, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.GetAbandonedCarts();
        });
    }

    onInvoiceClick(Item) {
        let disposable = this.dialogService.addDialog(InvoiceDetailsDialog, {
            invoiceItem: Item,
            memberName: Item.FirstName + ' ' + Item.LastName
        }, { height: 650 }).subscribe(response => {
            disposable.unsubscribe();
        }, error => {
            disposable.unsubscribe();
        });
    }

    GetAbandonedCarts() {
        this.IsBusy = true;
        let disposable = this.api.GetAbandonedCarts().subscribe((response) => {
            if (response.Result) {
                this.AbandonedCartItems = <AbandonedCartItemArray>response.Data.filter(item => item.isHidden == false);
                this.HiddenAbandonedCartItems = <AbandonedCartItemArray>response.Data.filter(item => item.isHidden == true);
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error Loading Items',
                    text: response.Message
                }).then(() => { }, () => { });
            }
            this.IsBusy = false;
            disposable.unsubscribe();
        });
    }

    HideItem(item: AbandonedCartItem) {
        let disposable = this.api.HideAbandonedCart(item.CartID).subscribe(response => {
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Cart Hidden',
                    timer: 1500
                }).then(() => { }, () => { });
                this.GetAbandonedCarts();
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                }).then(() => { }, () => { });
            }
            disposable.unsubscribe();
        });
    }

    NameForBillingCycle(id: number) {
        switch (id) {
            case 0:
                return 'One Time';
            case 1:
                return 'Monthly';
            case 2:
                return 'Yearly';
            default:
                return 'Unkown';
        }
    }

    NameForProduct(id: number) {
        switch (id) {
            case 3:
                return 'VIP3D';
            case 2:
                return 'Pool Studio';
            case 1:
                return 'VizTerra';
            case 5:
                return 'Yard';
            case 4:
                return 'VIP3D - Special';
        }
    }

    ShowHiddenCarts() {
        this.ShowHidden = !this.ShowHidden;
        if (this.ShowHidden) {
            this.HiddenCartLabel = 'Hide';
        } else {
            this.HiddenCartLabel = 'Show';
        }
    }

    ExportToCSV() {
        let options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: ['Created', 'Updated', 'FirstName', 'LastName', 'Email', 'Address', 'Company', 'City', 'State', 'ZipCode', 'Country', 'Product', 'Billing Cycle']
        };

        let ExportData = [];

        this.AbandonedCartItems.forEach(function (item) {
            ExportData.push({
                Created: item.DateTimeCreated,
                Updated: item.DateTimeUpdated,
                FirstName: item.FirstName,
                LastName: item.LastName,
                Email: item.Email,
                Address: item.Address,
                Company: item.Company,
                City: item.City,
                State: item.State,
                ZipCode: item.ZipCode,
                Country: item.Country,
                Product: item.ProductID,
                BillingCycle: item.BillingCycle
            });
        });

        new Angular2Csv(ExportData, 'AbandonedCartReport', options);
    }

    Title() {
        let title = 'Abandoned Carts';
        if (this.AbandonedCartItems && this.AbandonedCartItems.length > 0) {
            title += ' (' + this.AbandonedCartItems.length + ')';
        }

        return title;
    }

}
